import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { request } from "../request/request";
import { APP_URL } from "../request/api";

const initialState = {
    filterList: [],
    loaded: false,
    loadingStatus: "idle",
    error: null
}

export const fetchVehiclesFilters = createAsyncThunk(
    'vehiclesFilters/fetchVehiclesFilters',
    async ({token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            return await request(
                `${APP_URL}/vehicles/filter`,
                'GET',
                null,
                customHeaders
            );
        } catch (error) {
            rejectWithValue(error.status)
        }
    }
)

const vehiclesFilters = createSlice({
    name: "vehiclesFilters",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVehiclesFilters.pending, (state) => {
                state.filterList = [];
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchVehiclesFilters.fulfilled, (state, action) => {
                state.filterList = action.payload;
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchVehiclesFilters.rejected, (state, action) => {
                state.filterList = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
});

export default vehiclesFilters.reducer;